export default __webpack_public_path__ + "static/media/global-icon-two-hover.9cec778c.svg";